define(function (require, exports) {
    'use strict';
    
    var sdkinit = require('XmSdk');
    var waitableTicket = require("../../../widget-metro-soft-token/scripts/waitableTicket")
    var sdk = new sdkinit.XmSdk();

    var journey = '';
    var subModuleJourney ='';
    var updatedPassword = "";
    var promises = {};
    var jsonData = {};
    var self =this;


    /**
     * @ngInject
     */

    /* function CustomUIHandler() {
        sdkinit.XmUIHandler.call(this);
    }  */
    function metroUiHandler(lpCoreBus) {

         //############# Start BaseAuthenticatorSession prototype

        function BaseAuthenticatorSession (title, username, common) {
            this.supportsInlineError = false;
            this.title = title;
            this.username = username;
            this.common = common;
        }

        BaseAuthenticatorSession.prototype.baseConstructor = function(title, username, common) {
            this.supportsInlineError = false;
            this.title = title;
            this.username = username;
            this.common = common;
        }
        BaseAuthenticatorSession.prototype.startSession = function(description, mode, actionContext, clientContext) {
            this.description = description;
            this.mode = mode;
            this.actionContext = actionContext;
            this.clientContext = clientContext;
            this.common.log(`Starting session; session mode: [${this.mode}], authenticator: [${this.title}]`);
        }
        BaseAuthenticatorSession.prototype.changeSessionModeToRegistrationAfterExpiration = function() {
            this.common.log(`Changing session mode to registration after expiration; authenticator: [${this.title}]`);
            this.mode = com.ts.mobile.sdk.AuthenticatorSessionMode.Registration;
            this.authError = null;
        }
        BaseAuthenticatorSession.prototype.promiseRecoveryForError = function(error, validRecoveries, defaultRecovery) {
            this.common.log(`Starting error recovery; session mode: [${this.mode}], authenticator: [${this.title}], error: [${error}]`);
            if (this.supportsInlineError && defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator) {
                this.authError = error;
                return Promise.resolve(defaultRecovery);
            }
            else if (defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.Fail) {
                return Promise.resolve(defaultRecovery);
            }
            return this.common.promiseRecoveryForError(error, validRecoveries, defaultRecovery, this.clientContext);
        }
        BaseAuthenticatorSession.prototype.endSession = function() {
            this.common.log(`Ending session; session mode: [${this.mode}], authenticator: [${this.title}]`);
        }
        BaseAuthenticatorSession.prototype.promiseInput = function() {
            //this.common.setAriaBusy(this.clientContext);
            let promise;
            switch (this.mode) {
                case com.ts.mobile.sdk.AuthenticatorSessionMode.Authentication:
                    this.common.log(`Fetching authentication input; authenticator: [${this.title}]`);
                    //this.common.unsetAriaBusy(this.clientContext);
                    promise = this.promiseAuthInput();
                    break;
                case com.ts.mobile.sdk.AuthenticatorSessionMode.Registration:
                    this.common.log(`Fetching registration input; authenticator: [${this.title}]`);
                    //this.common.unsetAriaBusy(this.clientContext);
                    promise = this.promiseRegInput();
                    break;
            }
            return promise.then((input) => {
                //this.common.clearContainer(this.clientContext);
                return input;
            });
        }

    //############# End BaseAuthenticatorSession prototype



        function CustomUIHandler() {
         //   sdkinit.XmUIHandler.call(this);
        }  
        console.log(sdkinit)
        //CustomUIHandler.prototype = Object.create(sdkinit.XmUIHandler.prototype);
        CustomUIHandler.prototype.constuctor = CustomUIHandler;

        CustomUIHandler.prototype.selectAuthenticatorFallbackAction = function (validOptions, fallbackAuthenticator, session, actionContext, clientContext) {
            setKeyValue("softokenError", true)
            return new Promise(function (resolve, reject) {
                resolve({ abortSelection: true });
            })
        }

        CustomUIHandler.prototype.createFormSession = function (formId, payload) {
            return {
                getContainer: function (clientContext) {
                    return xmui.XmUIHandler.getContainer(clientContext);
                },
                startSession: function (clientContext, actionContext) {
                    this.actionContext = actionContext;
                    this.clientContext = clientContext;
                },
                promiseFormInput: function () {
                    if(formId) {
                        lpCoreBus.publish(journey+'.uiHandler.'+formId,payload);
                        return new Promise(function (resolve, reject) {
                            promises[journey] = {
                                "resolve" : resolve,
                                "reject" : reject
                            }
                        });
                    }
                },
                onContinue: function () {},
                onError: function (payload) {
                    console.log(payload)
                },
                endSession: function (payload) {
                    console.log(payload)
                }
            }
        }

        CustomUIHandler.prototype.processJsonData = function (jsonData) {
            //console.log("---> processJsonData", jsonData.promote_mobile_authenticator.promote_mobile_authenticator)
            if(jsonData.login_cross_session_id){
                setKeyValue("login_cross_session_id", jsonData.login_cross_session_id)
                //jsonData.login_cross_session_id  = jsonData.login_cross_session_id
            }
            if(jsonData.sca_soft_token_enabled) {
                lpCoreBus.publish('scaEnabled', true)
            }
            else{
                lpCoreBus.publish('scaEnabled', false)
            }

            if(jsonData.is_fake_journey){
                setKeyValue("isFirstFactorAuthenticationFailed", true)
                setKeyValue("softokenErrorMessage", jsonData.lock_rule_response)
            }


            return Promise.resolve(com.ts.mobile.sdk.JsonDataProcessingResult.create(true))
        }

        CustomUIHandler.prototype.createTicketWaitSession = function (actionContext, clientContext) {
            return new waitableTicket.TicketWaitSession(this.common);
        }

        CustomUIHandler.prototype.handlePolicyRejection = function handlePolicyRejection(title, text, buttonText, failureData, actionContext, clientContext) {
            console.log(`handlePolicyRejection requested.`);
            return Promise.resolve(com.ts.mobile.sdk.ConfirmationInput.create(-1)); // -1 for continue and 0 for reject
        };

        CustomUIHandler.prototype.handlePolicyRedirect = function handlePolicyRedirect(redirectType, policyId, userId, additionalParameters, clientContext) {
        console.log(`Policy redirection requested. redirecting to policy: [${policyId}] with additionalParameters: [${additionalParameters}]`);
        return Promise.resolve(com.ts.mobile.sdk.RedirectInput.create(com.ts.mobile.sdk.RedirectResponseType.RedirectToPolicy));
        }
        CustomUIHandler.prototype.controlFlowCancelled = function controlFlowCancelled(clientContext) {
            console.log("Control flow cancelled");
           // this.common.clearContainer(clientContext);
          }

        CustomUIHandler.prototype.shouldIncludeDisabledAuthenticatorsInMenu= function shouldIncludeDisabledAuthenticatorsInMenu(actionContext, clientContext) {
            console.log('shouldIncludeDisabledAuthenticatorsInMenu');
            return true;
        }

        waitableTicket.TicketWaitSession.prototype.setWaitingTicket = function(ticketWaitInfo){
            if(!jsonData.login_cross_session_id){
                lpCoreBus.publish('loadTickeUi',ticketWaitInfo)
            }
        }

        waitableTicket.TicketWaitSession.prototype.startSession = function(actionContext, clientContext){
            console.log(actionContext);
        }

        CustomUIHandler.prototype.selectAuthenticator = function (options, actionContext, clientContext) {
            return new Promise(function(resolve, reject) {
                if( options && options.length > 0){
                    var option;
                    options.forEach(function(op){
                        var authenticator = op.getAuthenticator();
                        if( authenticator["_authenticatorId"] == "totp" ){
                            option = op;
                        }
                    })

                    if(!option){
                        if(getKeyValue("isFirstFactorAuthenticationFailed")){
                            jsonData.softokenErrorMessage.biomatricDisabled = true
                            resolve(com.ts.mobile.sdk.AuthenticatorSelectionResult.createAbortRequest());
                        }
                        else{
                            lpCoreBus.publish('contentSoftotokeUIHandler', true)
                        }
                    }else{ 
                        var authenticator = option.getAuthenticator();
                        resolve(com.ts.mobile.sdk.AuthenticatorSelectionResult.createSelectionRequest(authenticator));
                    }
                }
            });
        }



        var MobileApproveAuthenticationState;
        (function (MobileApproveAuthenticationState) {
            MobileApproveAuthenticationState[MobileApproveAuthenticationState["TargetSelection"] = 0] = "TargetSelection";
            MobileApproveAuthenticationState[MobileApproveAuthenticationState["PollingRequested"] = 1] = "PollingRequested";
            MobileApproveAuthenticationState[MobileApproveAuthenticationState["PollingStarted"] = 2] = "PollingStarted";
        })(MobileApproveAuthenticationState || (MobileApproveAuthenticationState = {}));


        CustomUIHandler.prototype.createMobileApproveAuthSession = function (title, username, instructions){

            function MobileApproveAuthenticatorSession(){}
            MobileApproveAuthenticatorSession.prototype = Object.create(BaseAuthenticatorSession.prototype);

             MobileApproveAuthenticatorSession.prototype.constructor= function(title, username, instructions, common = console) {

                console.log("++++++++++++++++++++MobileApproveAuthenticatorSession")
                this.state = MobileApproveAuthenticationState.TargetSelection;
                this.pollingIntervalMillis = 3000;
                this.instructions = instructions;

                this.baseConstructor(title, username, common);

                return this;
            }

            MobileApproveAuthenticatorSession.prototype.setPollingIntervalInMillis = function(millis) {
                this.pollingIntervalMillis = millis;
            }
            MobileApproveAuthenticatorSession.prototype.setCreatedApprovalInfo = function(targets, otp) {
                if (targets != null) {
                    this.createdForTargets = targets;
                    this.otp = otp;
                    this.state = MobileApproveAuthenticationState.PollingRequested;
                }
                else {
                    this.createdForTargets = null;
                    this.otp = null;
                    this.state = MobileApproveAuthenticationState.TargetSelection;
                    clearTimeout(this.pollingTimer);
                    this.hidePendingUi();
                }
            }
            MobileApproveAuthenticatorSession.prototype.setAvailableTargets = function(targets) {
                this.availableTargets = targets;
            }
            MobileApproveAuthenticatorSession.prototype.endSession= function() {
                clearTimeout(this.pollingTimer);
               // this.common.clearContainer(this.clientContext);
            }
            MobileApproveAuthenticatorSession.prototype.promiseInput = function() {
                switch (this.mode) {
                    case com.ts.mobile.sdk.AuthenticatorSessionMode.Authentication:
                        //this.common.setAriaBusy(this.clientContext);
                        this.common.log("Fetching Mobile Approve authentication input;");
                        switch (this.state) {
                            case MobileApproveAuthenticationState.TargetSelection:
                                return this.promiseTargetSelectionInput();
                            case MobileApproveAuthenticationState.PollingRequested:
                                this.state = MobileApproveAuthenticationState.PollingStarted;
                                this.promisePendingUI().then((input) => {
                                    clearTimeout(this.pollingTimer);
                                this.hidePendingUi();
                                if (this.currentPollingResolver) {
                                    this.currentPollingResolver(input);
                                    this.currentPollingResolver = null;
                                }
                                else {
                                    this.pendingCancelRequest = input;
                                }
                        });
                        return this.startPolling();
                    case MobileApproveAuthenticationState.PollingStarted:
                        return this.startPolling();
                    default:
                        return Promise.reject("Illegal state");
                }
            case com.ts.mobile.sdk.AuthenticatorSessionMode.Registration:
                throw new Error("Method not implemented.");
            }
            }
            MobileApproveAuthenticatorSession.prototype.promiseTargetSelectionInput = function() {
                let authMobileAuthSelectDeviceForm = $('<div class="xmuiCore xmuiForm xmuiMobileAuthSelectDeviceForm">\
                <div class="xmuiPrompt" data-xmui-customstringtext="mobileAuthDeviceSelection.selectDevices"/>\
                <div class="xmuiFullHeightContentBelowPrompt xmuiAuthMobileDeviceSelection">\
                    <div class="xmuiAuthMobileDeviceSelectionList"></div>\
                    <div style="align-items: center;">\
                        <button class="xmuiLoginButton" type="submit" data-xmui-customstringtext="mobileAuthDeviceSelection.select"/>\
                    </div>\
                </div>\
            </div>');
                let authMobileDeviceSelectionList = authMobileAuthSelectDeviceForm.find(".xmuiAuthMobileDeviceSelectionList");
                let selectButton = authMobileAuthSelectDeviceForm.find(".xmuiLoginButton");
                let selectionPrompt = authMobileAuthSelectDeviceForm.find(".xmuiPrompt");
                this.common.appendElement(authMobileAuthSelectDeviceForm, this.clientContext);
                return new Promise((resolve, reject) => {
                    this.availableTargets.forEach((target) => {
                        let description = target.getDescription();
                let inputElement = $("<input/>").attr({
                    id: "xmui_device_" + description,
                    name: "xmui_device_" + description,
                    type: 'checkbox'
                }).data('xmui_device_id', target);
                let labelElement = $("<label/>")
                    .attr("htmlFor", "xmui_device_" + description)
                    .text(description)
                    .css("font-size", "10pt");
                authMobileDeviceSelectionList
                    .append(inputElement)
                    .append(labelElement)
                    .append($("<br/>"));
            });
                selectButton.click(() => {
                    let selectedTargets = [], checkedCheckboxes = authMobileAuthSelectDeviceForm.find('input:checkbox:checked');
                checkedCheckboxes.each((index, element) => {
                    selectedTargets.push($(element).data('xmui_device_id'));
            });
                if (selectedTargets.length <= 0) {
                    selectionPrompt.text(this.common.resolveString("mobileApprove.deviceSelection.noneError"));
                    selectionPrompt.addClass("xmuiPromptError");
                    selectionPrompt.attr("role", "alert").attr("aria-label", this.common.resolveString("aria.noDeviceSelected"));
                }
                else {
                    authMobileAuthSelectDeviceForm.fadeOut(() => {
                        let input = com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createTargetsSelectionRequest(selectedTargets);
                    resolve(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(input));
                });
                }
            });
                this.common.prependPageHeader(authMobileAuthSelectDeviceForm, this.title, resolve);
            }).then((input) => {
                    //this.common.unsetAriaBusy(this.clientContext);
               // this.common.clearContainer(this.clientContext);
                return input;
            });
            }
            MobileApproveAuthenticatorSession.prototype.promisePendingUI = function() {
                return new Promise(function(resolve, reject) {  
                    var formName =  (subModuleJourney == "password-update") ? "COB_SCA_ST_PW_form" : "COB_SCA_ST_form"
                    lpCoreBus.publish('user_hrp_journey.uiHandler.'+formName,{"softToken":true, "promiseResolve":resolve, "endSession": MobileApproveAuthenticatorSession.prototype.endSession});
                });
            }
            MobileApproveAuthenticatorSession.prototype.updateOtp = function() {
                if (this.otp) {
                    let otpFormatType = this.otp.getFormat().getType();
                    switch (otpFormatType) {
                        case com.ts.mobile.sdk.OtpFormatType.Numeric:
                            let text = $(".xmuiMobileAuthForm").find(".xmuiOtpText");
                            text.text(this.otp.getValue());
                            text.show();
                            break;
                        case com.ts.mobile.sdk.OtpFormatType.QrCode:
                            let img = $(".xmuiMobileAuthForm").find(".xmuiOtpImg");
                            img.attr("src", "data:image/jpeg;base64," + this.otp.getValue());
                            img.show();
                            break;
                        default:
                            this.common.log("Unsupported otp format");
                            throw new Error("Unsupported otp format");
                    }
                }
            }
            MobileApproveAuthenticatorSession.prototype.hidePendingUi = function() {
                //this.common.unsetAriaBusy(this.clientContext);
                $(".xmuiMobileAuthForm").hide();
            }
            MobileApproveAuthenticatorSession.prototype.promiseRecoveryBaseForError = function(error, validRecoveries, defaultRecovery) {
                 console.log(error)
                this.common.log(`Starting error recovery; session mode: [${this.mode}], authenticator: [${this.title}], error: [${error}]`);
                if (this.supportsInlineError && defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator) {
                    this.authError = error;
                    return Promise.resolve(defaultRecovery);
                }
                else if (defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.Fail) {
                    return Promise.resolve(defaultRecovery);
                }
                return this.common.promiseRecoveryForError(error, validRecoveries, defaultRecovery, this.clientContext);
            }
            MobileApproveAuthenticatorSession.prototype.promiseRecoveryForError = function(error, validRecoveries, defaultRecovery) {
                return new Promise( (resolve, reject)=>{
                    if (error.getErrorCode() == com.ts.mobile.sdk.AuthenticationErrorCode.ApprovalExpired )
                    {
                       resolve( com.ts.mobile.sdk.AuthenticationErrorRecovery.SelectAuthenticator)
                    }
                    else if(error.getErrorCode() == com.ts.mobile.sdk.AuthenticationErrorCode.ApprovalDenied){
                        lpCoreBus.publish('softoken-declined');
                        resolve({ abortSelection: true });
                    }
            });
            }
            MobileApproveAuthenticatorSession.prototype.startPolling = function() {
                return new Promise((resolve, reject) => {
                    this.updateOtp();
                this.pollingTimer = setTimeout(() => {
                    this.currentPollingResolver = null;
                if (this.pendingCancelRequest) {
                    resolve(this.pendingCancelRequest);
                }
                else {
                    resolve(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createAuthenticatorInput(com.ts.mobile.sdk.MobileApproveInputRequestPolling.createRequestPollingInput())));
                }
            }, this.pollingIntervalMillis);
                this.currentPollingResolver = resolve;
            });
            }
            MobileApproveAuthenticatorSession.prototype.promiseAuthInput = function() {
                throw new Error("Method not implemented");
            }
            MobileApproveAuthenticatorSession.prototype.promiseRegInput = function() {
                throw new Error("Method not implemented");
            }

            MobileApproveAuthenticatorSession.prototype.promiseCancelAction = function(options, clientContext){
                var controlRequest = com.ts.mobile.sdk.ControlRequest.create(com.ts.mobile.sdk.ControlRequestType.ChangeMethod);
                console.log(controlRequest.getRequestType())
                return Promise.resolve(controlRequest);
            }

            return new MobileApproveAuthenticatorSession().constructor(title, username, instructions, this.common);
        }

        CustomUIHandler.prototype.controlOptionForCancellationRequestInSession = function(validOptions, session) {
            return session.promiseCancelAction(validOptions, session.clientContext);
        }



        CustomUIHandler.prototype.createTotpAuthSession= function(title, username) {
            function TotpAuthenticatorSession(title, username, common = console){
                this.title = title;
                this.username = username;
                this.common = common;
            }

            TotpAuthenticatorSession.prototype.setAvailableTargets = function(targets){
            

                this.availableTargets = targets;
            }

            TotpAuthenticatorSession.prototype.startSession = function(description, mode, actionContext, clientContext) {
                this.description = description;
                this.mode = mode;
                this.actionContext = actionContext;
                this.clientContext = clientContext;
                this.common.log(`Starting session; session mode: [${this.mode}], authenticator: [${this.title}]`);
            }

            TotpAuthenticatorSession.prototype.promiseRecoveryBaseForError = function(error, validRecoveries, defaultRecovery) {

                this.common.log(`Starting error recovery; session mode: [${this.mode}], authenticator: [${this.title}], error: [${error}]`);
                if (this.supportsInlineError && defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator) {
                    console.log("promiseRecoveryBaseForError -> RetryAuthenticator", error)
                    this.authError = error;
                    return Promise.resolve(defaultRecovery);
                }
                else if (defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.Fail) {
                    console.log("promiseRecoveryBaseForError -> Fail", error)
                    return Promise.resolve(defaultRecovery);
                }
                console.log("promiseRecoveryBaseForError -> ", defaultRecovery, error)
                return this.common.promiseRecoveryForError(error, validRecoveries, defaultRecovery, this.clientContext);
            }

            TotpAuthenticatorSession.prototype.endSession= function(){
                if(this.common){
                    this.common.log(`Ending session; session mode: [${this.mode}], authenticator: [${this.title}]`);
                    clearTimeout(this.pollingTimer);
                }
            }


            TotpAuthenticatorSession.prototype.changeSessionModeToRegistrationAfterExpiration = function() {
                this.common.log(`Changing session mode to registration after expiration; authenticator: [${this.title}]`);
                this.mode = com.ts.mobile.sdk.AuthenticatorSessionMode.Registration;
                this.authError = null;
            }


            TotpAuthenticatorSession.prototype.promiseInput = function() {
               // this.common.setAriaBusy(this.clientContext);
                let promise;
                switch (this.mode) {
                    case com.ts.mobile.sdk.AuthenticatorSessionMode.Authentication:
                        this.common.log(`Fetching authentication input; authenticator: [${this.title}]`);
                        //this.common.unsetAriaBusy(this.clientContext);
                        promise = this.promiseAuthInput();
                        break;
                    case com.ts.mobile.sdk.AuthenticatorSessionMode.Registration:
                        this.common.log(`Fetching registration input; authenticator: [${this.title}]`);
                       // this.common.unsetAriaBusy(this.clientContext);
                        promise = this.promiseRegInput();
                        break;
                }
                return promise.then((input) => {
                    //this.common.clearContainer(this.clientContext);
                    return input;
                });
            }

            TotpAuthenticatorSession.prototype.setTargetDevices = function(targets){

                this.targetDevices = targets;
            }

            TotpAuthenticatorSession.prototype.setChallenge = function(challenge){
     
                this.challenge = challenge;
            }

            TotpAuthenticatorSession.prototype.promiseAuthInput = function(){

                if (this.availableTargets && !this.targetDevices) {
                    return this.promiseTargetSelectionInput();
                }
                else {
                    return this.promiseCodeInput();
                }
            }


            TotpAuthenticatorSession.prototype.promiseRecoveryForError = function(error, validRecoveries, defaultRecovery) {
                console.log(error.getErrorCode() , com.ts.mobile.sdk.AuthenticationErrorCode.InvalidInput, "\n"
                    , validRecoveries, com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator, "\n"
                    , defaultRecovery)

                var errorAction = com.ts.mobile.sdk.AuthenticationErrorRecovery.Fail;

                if (error.getErrorCode() == com.ts.mobile.sdk.AuthenticationErrorCode.InvalidInput &&
                        validRecoveries.indexOf(com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator) >= 0) {
    
                        //TODO: Show message for wrong TOTP and retry
                        //$scope.totpInvalidInput = true;
                        errorAction = com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator;
                    }
                    return Promise.resolve(errorAction);

            }


            TotpAuthenticatorSession.prototype.promiseTargetSelectionInput = function(){
                let totpSelectDeviceForm = $('<div class="xmuiCore xmuiForm xmuiTotpSelectDeviceForm">\
                        <div class="xmuiPrompt" data-xmui-customstringtext="totpDeviceSelection.selectDevices"/>\
                        <div class="xmuiFullHeightContentBelowPrompt xmuiAuthMobileDeviceSelection">\
                            <div class="xmuiTotpDeviceSelectionList"></div>\
                            <div style="align-items: center;">\
                                <button class="xmuiLoginButton" type="submit" data-xmui-customstringtext="mobileAuthDeviceSelection.select"/>\
                            </div>\
                        </div>\
                    </div>');
                let totpDeviceSelectionList = totpSelectDeviceForm.find(".xmuiTotpDeviceSelectionList");
                let totpSelectDeviceFormSelectButton = totpSelectDeviceForm.find(".xmuiLoginButton");
                let selectionPrompt = totpSelectDeviceForm.find(".xmuiPrompt");
                this.common.appendElement(totpSelectDeviceForm, this.clientContext);
                return new Promise((resolve, reject) => {
                    this.availableTargets.forEach((target) => {
                        let description = target.getDescription();
                        var inputElement = $("<input/>").attr({
                            id: "xmui_device_" + description,
                            name: "xmui_device_" + description,
                            type: 'checkbox'
                        }).data('xmui_device_id', target);
                        var labelElement = $("<label/>")
                            .attr("htmlFor", "xmui_device_" + description)
                            .text(description)
                            .css("font-size", "10pt");
                        totpDeviceSelectionList
                            .append(inputElement)
                            .append(labelElement)
                            .append($("<br/>"));
                    });
                    totpSelectDeviceFormSelectButton.click(() => {
                        var selectedTargets = [], checkedCheckboxes = totpSelectDeviceForm.find('input:checkbox:checked');
                        checkedCheckboxes.each((index, element) => {
                            selectedTargets.push($(element).data('xmui_device_id'));
                        });
                        if (selectedTargets.length <= 0) {
                            selectionPrompt.text(this.common.resolveString("totp.deviceSelection.noneError"));
                            selectionPrompt.addClass("xmuiPromptError");
                            selectionPrompt.attr("role", "alert").attr("aria-label", this.common.resolveString("aria.noDeviceSelected"));
                        }
                        else {
                            totpSelectDeviceForm.fadeOut(() => {
                                let input = com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createTargetsSelectionRequest(selectedTargets);
                                resolve(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(input));
                            });
                        }
                    });
                    this.common.prependPageHeader(totpSelectDeviceForm, this.title, resolve);
                });
            }


            TotpAuthenticatorSession.prototype.promiseCodeInput = function() {
                var self = this;
                return new Promise((resolve, reject) => {
                    if (self.challenge) {
                        switch (self.challenge.getFormat().getType()) {
                            case com.ts.mobile.sdk.TotpChallengeFormatType.Numeric:
                            case com.ts.mobile.sdk.TotpChallengeFormatType.AlphaNumeric:
                                console.log(self.challenge.getValue())
                                break;
                            case com.ts.mobile.sdk.TotpChallengeFormatType.QrCode:
                                lpCoreBus.publish('user_payment_journey.uiHandler.showQRcode', self.challenge.getValue());
                                break;
                        }
                    }
                    else {
                        //prompt = this.common.resolveString("totp.instructions");
                    }
                   
                    var resolveSoftTokenPromise = {
                        "resolve" : resolve,
                        "reject" : reject
                    }
                    lpCoreBus.publish('user_hrp_journey.uiHandler.showTotp', resolveSoftTokenPromise);
                });

            }

            TotpAuthenticatorSession.prototype.promiseRegInput = function(){
                throw new Error("Method not implemented.");
            }

            return new TotpAuthenticatorSession(title, username, this.common);
        }
        CustomUIHandler.prototype.startActivityIndicator = function(){
            console.log('<><><><>CAlled start UI indicator')
          }
          CustomUIHandler.prototype.endActivityIndicator = function(){
            console.log('<><><><>CAlled end UI indicator')
          }
        
          CustomUIHandler.prototype.controlFlowStarting = function(
            clientContext
          ) {
            console.log('control flow starting');
            console.log(clientContext);
          };
        
          CustomUIHandler.prototype.controlFlowActionStarting = function(
            clientContext
            ) {
            console.log('control flow action starting');
            console.log(clientContext);
          };
        
          CustomUIHandler.prototype.controlFlowActionEnded = function(
            clientContext
            ) {
            console.log('control flow action ending');
            console.log(clientContext);
          };
        
          CustomUIHandler.prototype.controlFlowEnded = function(
            clientContext
            ) {
            console.log('control flow ending');
            console.log(clientContext);
          };


        function setJourney(journeyName, subJourney){//subJourney
            journey = journeyName;
            subModuleJourney = subJourney;
        }
        function resolvePromise(journey,requestObject){
            var formInput = com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(requestObject);
            promises[journey].resolve(formInput);
        }
        function rejectPromise(journey){
            promises[journey].reject(false);
        }
        function setKeyValue(obj, value){
            jsonData[obj] = value;
        }

        function resetJsonProviderData(){
            jsonData = {};
        }

        function getKeyValue(obj){
            console.log(jsonData)
            return jsonData[obj];
        }

        return {
            CustomUIHandler : new CustomUIHandler(),
            setJourney : setJourney,
            getKeyValue:getKeyValue,
            resolvePromise : resolvePromise,
            rejectPromise : rejectPromise,
            resetJsonProviderData: resetJsonProviderData,
        };
    }

    /**
     * Exports
     */
    exports.metroUiHandler = metroUiHandler;
});



// WEBPACK FOOTER //
// ./scripts/services/metroUiHandler.js